import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NewsArticle } from 'app/profile/news/news-profile.model';
import { NewsService } from 'app/profile/news/news-profile.service';
import { CaseFormSectionContainerComponent } from 'app/shared/components/forms/case-form-section-container/case-form-section-container.component';
import { NewsPreviewComponent } from 'app/shared/components/news-preview/news-preview.component';
import { PaginationComponent } from 'app/shared/components/pagination/pagination.component';

@Component({
  selector: 'app-news-and-announcements',
  standalone: true,
  imports: [CommonModule, CaseFormSectionContainerComponent, NewsPreviewComponent, PaginationComponent],
  templateUrl: './news-and-announcements.component.html',
  styleUrl: './news-and-announcements.component.scss'
})
export class NewsAndAnnouncementsComponent {
  news: NewsArticle[] = [];
  currentPage: number = 1;
  totalNewsCount: number = 0;
  selectedPageSize: number = 5;
  pageSizeOptions = [5, 10, 20];

  constructor(private newsService: NewsService, private router: Router) {}

  ngOnInit(): void {
    this.getNews();
  }

  getNews(): void {
    const params = {
      skipCount: (this.currentPage - 1) * this.selectedPageSize,
      takeCount: this.selectedPageSize,
      orderField: 'Id',
      isOrderByDescending: true,
    };

    this.newsService.getAllNews(params).subscribe(newsArticles => {
      this.news = newsArticles.map(article => ({
        ...article,
        text: article.shortBody || article.body,
        author: article.autorName,
        dateTime: article.publishDate ? new Date(article.publishDate) : new Date(),
        views: article.viewsCount,
      }));
    });

    if (this.totalNewsCount === 0) {
      this.newsService.getNewsCount().subscribe(count => {
        this.totalNewsCount = count;
      });
    }
  }

  onViewNews(newsItem: NewsArticle): void {
    this.router.navigate(['/news-details', newsItem.id]);
  }

  onPageSelect(page: number): void {
    this.currentPage = page;
    this.getNews();
  }

  onItemsPerPageChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
    this.currentPage = 1;
    this.getNews();
  }
}
